/**
 * runtimeEnv - 런타임 환경변수 접근자
 *
 * 우선순위:
 *   1. `window.__ENV__[key]`  <- 컨테이너 기동 시 docker-entrypoint.sh 가 주입 (배포 환경)
 *   2. `process.env.REACT_APP_{key}`  <- 로컬 개발용 fallback (`npm start` + .env)
 *   3. `fallback` 인자
 *
 * 주의: 배포 이미지의 Dockerfile 에는 `REACT_APP_*` ARG/ENV 가 **없다**.
 * 즉 CI 빌드에서는 2번 경로로 값이 박힐 수 없고, 항상 1번(런타임)만 유효하다.
 * 새 환경변수를 추가할 때 Dockerfile 에 REACT_APP_* 를 되살리지 말 것 —
 * 그러면 이미지가 다시 환경 의존이 되어 promote 가 깨진다.
 */
// 로컬 개발용 fallback. CRA 는 정적 참조만 치환하므로 동적 인덱스 접근을 피해
// 여기에 명시적으로 나열한다. (배포 이미지에서는 전부 undefined 다)
const localFallback = {
  AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
  AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
  AZURE_REDIRECT_URI: process.env.REACT_APP_AZURE_REDIRECT_URI,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
};

const isSet = (v) => v !== undefined && v !== null && v !== "";

export function getEnv(key, fallback = undefined) {
  const runtime =
    typeof window !== "undefined" && window.__ENV__ ? window.__ENV__[key] : undefined;
  if (isSet(runtime)) {
    return runtime;
  }

  if (isSet(localFallback[key])) {
    return localFallback[key];
  }

  return fallback;
}

export default getEnv;
